import { render, staticRenderFns } from "./IndustryBusiness.vue?vue&type=template&id=8dabeefa"
import script from "./IndustryBusiness.vue?vue&type=script&lang=js"
export * from "./IndustryBusiness.vue?vue&type=script&lang=js"
import style0 from "./IndustryBusiness.vue?vue&type=style&index=0&id=8dabeefa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports